module.exports = __webpack_public_path__ + "static/bg10-09a61a89004078c1338dc9b1d06cf1e5.webp";